
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.497 3.668L10.586.772a1.823 1.823 0 00-1.145 0L.538 3.668a.805.805 0 00-.53.753c0 6.46 2.627 12.544 7.213 16.693a4.159 4.159 0 002.796 1.083c1 0 1.998-.361 2.797-1.083C17.4 16.965 20.027 10.88 20.027 4.42v-.023a.775.775 0 00-.53-.73zm-8.573 13.351a.77.77 0 01.768.769c0 .43-.346.768-.768.768H9.11a.766.766 0 01-.768-.768.77.77 0 01.768-.769h.138v-1.843H7.475a.77.77 0 01-.768-.769.77.77 0 01.768-.768h.499V6.35c0-.2.085-.4.23-.538l1.268-1.275a.804.804 0 011.09 0l1.268 1.275a.75.75 0 01.23.538v7.29h.5a.77.77 0 01.768.768.77.77 0 01-.768.769h-1.774v1.843h.138z","fill":"#E7E5EC"}})])
          )
        }
      }
    